import { Contributors } from "../interfaces/Contributors";

export const influencer: Contributors[] = [
  {
    id: 1,
    name: "Lilly Lopane",
    education: "",
    category: "Nikolay Influencer",
    market: "Nikolay Market Influencer",
    country: "USA, FL",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Lilly_Lopane.png",
    instagram: {
      name: "lilliannathedancer",
      url: "https://www.instagram.com/lilliannathedancer",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/logo_nikolay_made.png",
      name: "Nikolay Orlando",
      office: "nikolay, flagship boutique and office",
      address: "7003 Presidents Drive, Suite 600 Orlando, FL 32809, USA",
      tel: "+1 (321) 341 0151",
      website: "www.nikolay-world.com",
      instagram: {
        name: "nikolayworld",
        url: "https://www.instagram.com/nikolayworld",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
        Lilly started training at the age of 4. This is when she knew that ballet was her passion
        and was something she wanted to make a career. At the age of 9 Lilly went en pointe.
        Her first pointe shoes were the Nova Flex along with all of her other amazing NG products.
      </p>
      <p class="p_contributors">
        At the age of 11 Lilly moved to Florida to pursue her love for ballet.
        She got many performance opportunities such as Clara in Orlando Ballet’s Nutcracker,
        Crystal Fountain Variation from Sleeping Beauty, and others.
      </p>
      <p class="p_contributors">
        Through all of Lilly‘s training she has always worn Nikolay!
        She is thrilled to be an influencer for her dream brand and excited to share her journey.
        100% Nikolay girl.
      </p>
    `,
    accomplishmentsHtml: "",
  },

  {
    id: 2,
    name: "Shelby Guetzkow",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Shelby_Guetzkow.jpg",
    instagram: {
      name: "shelbylynndancer",
      url: "https://www.instagram.com/shelbylynndancer",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/the_dance_shoppe.webp",
      name: "The Dance Shoppe",
      office: "",
      address: "303 East Imperial Highway La Habra, CA 90631",
      tel: "+1 (714) 870-0554",
      website: "www.discountdanceshoppe.com",
      instagram: {
        name: "thedanceshoppeoc",
        url: "https://www.instagram.com/thedanceshoppeoc",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
        Shelby Guetzkow began dancing at the age of 3 and her favorite styles are classical and modern dance.
        Currently, she attends Orange County School of the Arts in the Ballet and Contemporary Dance conservatory.
        Shelby is a member of the pre-professional company at Los Alamitos Ballet Theatre.
      </p>
      <p class="p_contributors">
        She loves working with The Dance Shoppe and is honored to represent their store as a Nikolay Influencer.
        Shelby competed in many competitions such as Youth America Grand Prix, Universal Ballet Competition,
        and Kids Artistic Revue where she has been awarded top overall soloist,
        KAR Miss Teen Dance finalist, and KAR Protégé.
      </p>
      <p class="p_contributors">
        She has attended several summer intensives with prestigious companies such as the John Cranko Schule,
        Ballet West, Joffrey Red, and American Ballet Theatre.
        Shelby is a straight-A student and a member of the National Honor Society for Dance Arts at her school.
        Outside of dance and school, Shelby enjoys sitting on the beach with a good book and a matcha latte.
      </p>
    `,
    accomplishmentsHtml: "",
  },

  {
    id: 3,
    name: "Caitlyn Dioneda",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "CA, USA",
    birth: "08/30/2010",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Caitlyn_Dioneda.jpg",
    instagram: {
      name: "caitlyn.d_ballet",
      url: "https://www.instagram.com/caitlyn.d_ballet",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/the_dance_shoppe.webp",
      name: "The Dance Shoppe",
      office: "",
      address: "303 East Imperial Highway La Habra, CA 90631",
      tel: "+1 (714) 870-0554",
      website: "www.discountdanceshoppe.com",
      instagram: {
        name: "thedanceshoppeoc",
        url: "https://www.instagram.com/thedanceshoppeoc",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
        Caitlyn is 13 years old, from Oceanside, California.
        She began dancing at the age of 3 and trains at North County Academy of Dance
        in their pre-professional program where she has grown her technique, artistry, and love of dance.
        This past year, she was cast as Clara in the 2023 NCAD’s “The Nutcracker.”
      </p>
      <p class="p_contributors">
        She competed at YAGP and has been a soloist and finalist since 2021,
        earning 1st Place in Junior Classical, 2nd Place in Junior Classical Pas de Deux,
        and Top 12 in Contemporary.
        She was invited to compete at the 25th YAGP 2024 Anniversary Celebration in New York, NY.
      </p>
      <p class="p_contributors">
        Caitlyn has received numerous awards such as the 2024 Junior Aspire Dance Award,
        1st Place in Junior Classical Solo, and Top 5 in Contemporary.
        She has been a California Dance Classics Finalist for two years,
        with Gold and Silver Awards in Classical and Contemporary Solos.
      </p>
      <p class="p_contributors">
        She has attended prestigious Summer Intensives including
        School of American Ballet, Houston Ballet, Boston Ballet, Joffrey Ballet NYC, and many others.
        Currently, she wears Nikolay StreamPointe and DreamStretch ballet slippers,
        and is proud to represent Nikolay and The Dance Shoppe as a Market Influencer.
      </p>
    `,
    accomplishmentsHtml: `
      <ul class="list_contributors">
        <li>2023 NCAD Clara in “The Nutcracker” at NCAD</li>
        <li>2024 YAGP Junior 1st Place Classical solo</li>
        <li>2024 YAGP Junior 2nd Place Pas de deux</li>
        <li>2024 YAGP Top 12 Junior Contemporary solo</li>
        <li>‘21-‘24 YAGP Finalist</li>
        <li>2023 YAGP Junior 2nd Place Classical Solo</li>
        <li>2023 YAGP Junior 3rd Place Contemporary Solo</li>
        <li>2022 YAGP Pre-Competitive 3rd Place Classical Solo</li>
        <li>2022 YAGP Pre-Competitive 3rd Place Contemporary Solo</li>
        <li>2021 YAGP Top 12 Classical Solo</li>
        <li>2021 YAGP Top 12 Contemporary Solo</li>
        <li>2024 UBC Aspire Dance Award</li>
        <li>2024 UBC 5th Place Competitive Contemporary Solo</li>
        <li>'23-'24 UBC Finalist</li>
        <li>2023 UBC 1st Place Competitive Classical Solo</li>
        <li>2024 2023 UBC Top 10 Competitive Contemporary Solo</li>
        <li>2024 ADCIBC 1st Place Junior Classical Solo</li>
        <li>2024 ADCIBC 1st Place Junior Contemporary Solo</li>
        <li>‘24 ADCIBC Finalist</li>
        <li>2024 ICONIC Dance Award</li>
        <li>2024 ICON Dance Awards Top 5</li>
        <li>2023 ICON Dance Awards Junior Top 10 Overall Classical Solo</li>
        <li>2024 California Dance Classics Silver Award Classical Solo</li>
        <li>2023 California Dance Classics Gold Award Classical Solo</li>
        <li>2023 California Dance Classics Silver Award Contemporary Award</li>
        <li>2023 California Dance Classics Gala, Contemporary Soloist</li>
        <li>‘23-‘24 California Dance Classics Finalist</li>
        <li>2023 World Ballet Art Competition Grand Prix Junior 2nd Place Classical Solo</li>
        <li>2023 World Ballet Art Competition Grand Prix Junior 1st Place Contemporary Solo</li>
      </ul>
    `,
  },

  {
    id: 4,
    name: "Lola Sacks",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA, FL",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Lola_Sacks.jpg",
    instagram: {
      name: "lola._.dancer",
      url: "https://www.instagram.com/lola._.dancer",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/logo_nikolay_made.png",
      name: "Nikolay Orlando",
      office: "nikolay, flagship boutique and office",
      address: "7003 Presidents Drive, Suite 600 Orlando, FL 32809, USA",
      tel: "+1 (321) 341 0151",
      website: "www.nikolay-world.com",
      instagram: {
        name: "nikolayworld",
        url: "https://www.instagram.com/nikolayworld",
      },
    },
    descriptionHtml: ``,
    accomplishmentsHtml: "",
  },

  {
    id: 5,
    name: "Leilani Kalil",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA, FL",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Leilani_Kalil.jpg",
    instagram: {
      name: "leilani.kalil",
      url: "https://www.instagram.com/leilani.kalil",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/dancing_dupplies_depot.gif",
      name: "Dancing Supplies Depot",
      office: "",
      address: "10556 SW 8th St, Miami, FL 33174, USA",
      tel: "+1 (305) 226-0666",
      website: "www.dancingsuppliesdepot.com",
      instagram: {
        name: "dancingsuppliesdepot",
        url: "https://www.instagram.com/dancingsuppliesdepot",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
         Hi, my name is Leilani Kalil and I am 13 years old. I was born and raised in South Florida.
         I have an international background from Puerto Rico, Dominican Republic, Spain and Lebanon.
         My passion for dance was introduced to me when I started ballet at just 3 years old at Pembroke Ballet.
         Mrs. Gypsy Hall, owner and teacher of Pembroke Ballet, has taught me my very first ballet steps and has
         prepared me to go on pointe when I was 7 years old.
      </p>
      <p class="p_contributors">
      I began competing just two years ago and I look forward to participating in many more in the future:
      2022- (Dance Open America) 3rd place in contemporary and top 20 in classical
      2023-(Dance Open America) 6th in classical and top 10 in contemporary
      2024-(UBC) 14th place in classical
      (UBC platinum in Kitri)
      </p>
      <p class="p_contributors">
      Lastly, I have always loved the brand Nikolay ever since I tried it for the first time because they are incredibly comfortable, 
      reliable, and elegant. In 2022 my dream came true of becoming an NGgeneration Ambassador and now and I am beyond thrilled to be
      named an influencer to this amazing brand, Nikolay.
      </p>`,
    accomplishmentsHtml: "",
  },

  {
    id: 6,
    name: "Elizabeth Guzman",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA, MI",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Elizabeth_Guzman.jpg",
    instagram: {
      name: "lizzyanneguzman",
      url: "https://www.instagram.com/lizzyanneguzman/",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/Fanci_Footwork.webp",
      name: "Fanci Footworks",
      office: "",
      address: "48724 Gratiot, Chesterfield, 48051, USA",
      tel: "+1 (586) 738-6530",
      website: "www.fancifootworks.com",
      instagram: {
        name: "fancifootworks",
        url: "https://www.instagram.com/fancifootworks",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
      Elizabeth began her dance training at the age of three. She began her formal ballet training with Inland Pacific Ballet (@inlandpacificballet) at age five.
      She is also trained in contemporary, modern, tap and musical theater and has performed in several classical ballet and musical theater productions.
      </p>
      <p class="p_contributors">
      What she loves most about ballet is performing; that feeling of pure joy she feels on stage is very special. 
      She loves to tell story through movement and expressing herself by dance. When she is not dancing, she loves
       to sing, listen to music and spend time with her family and friends.
      </p>
     `,
    accomplishmentsHtml: "",
  },

  {
    id: 7,
    name: "Mackenzie Roark",
    education: "Colorado Ballet Academy",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "CO, USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Mackenzie_Roark.jpg",
    instagram: {
      name: "little_dancer_mac",
      url: "https://www.instagram.com/little_dancer_mac/",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/Fanci_Footwork.webp",
      name: "Fanci Footworks",
      office: "",
      address: "48724 Gratiot, Chesterfield, 48051, USA",
      tel: "+1 (586) 738-6530",
      website: "www.fancifootworks.com",
      instagram: {
        name: "fancifootworks",
        url: "https://www.instagram.com/fancifootworks",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
      Mackenzie began dancing at the age of 3 and was a competitive dancer. She was trained in ballet, tap, contemporary, jazz and hip hop.
      At the age of 10 she made the transition to <a href="https://www.instagram.com/coloradoballetacademy" class="p_link" target="_blank">coloradoballetacademy</a>
      and began to focus on ballet and modern. She has never looked back.Her first pair of pointe shoes was
       <a href="https://www.instagram.com/nikolayworld" class="p_link" target="_blank">nikolayworld</a> and she has been with them since!
      </p>
      <p class="p_contributors">
      What she loves most about ballet is being able to tell a story through her movement and the feeling of sharing what she loves to do on stage! She is passionate 
      about ballet and hopes to make her dream of being with a company true one day by never giving up and hard work every day! When she isn’t dancing, which is rare,
       she enjoys spending time with her family traveling the world!
      </p>

      <p class="p_contributors">
       Make it a Fanci Day!!!
      </p
     `,
    accomplishmentsHtml: "",
  },

  {
    id: 8,
    name: "Ruby Graham",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA",
    birth: "02/12/2009",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Ruby_Graham.jpg",
    instagram: {
      name: "rubylynngraham",
      url: "https://www.instagram.com/rubylynngraham",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/J_aila_pointe.jpg",
      name: "J'ai la Pointe - Got the pointe Dance Boutique",
      office: "",
      address: "109 W Main St Ste C Royse City, Tx 75189",
      tel: "+1 (469) 920-5430",
      website: "www.jailapointe.com",
      instagram: {
        name: "jailapointegotthepointe",
        url: "https://www.instagram.com/jailapointegotthepointe",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
       Ruby Graham is 15 years old from Rockwall, Texas. This is her first season at Hathaway Academy of Ballet and she is a Senior Company member of Collin County
       Ballet Theatre. Ruby started ballet at 21 and trained with Sharon Steele at Harmonic Motion School of Classical Ballet for 13 years. For the last two summers
       Ruby attended 6 week summer intensives with The Rock School for Dance Education in Philadelphia. In 2022, she attended ABT’s virtual summer intensive and 
       coaching with Marina Medvetskaya formerly of St. Petersburg, Russia. Ruby has competed at YAGP in several locations including Houston, Dallas, Nashville and Indianapolis.
        In 2022, she was named top 12 small ensemble in Dallas. For the last 3 years Ruby designed her costumes for competition. Outside of dance, Ruby enjoys fashion design where
         she received first place at FCCLA Fashion Design regional and state competitions as a freshman.
      </p>
      <p class="p_contributors">
    Most recently, Ruby was selected as a Nikolay Market Influencer on behalf of J’ai La Pointe. Currently she wears 3007 Pros and loves her Nikolay pointe shoes and apparel. She plans to
      pursue dance and fashion design in the future.
      </p>
       <p class="p_contributors">"You don't have to be perfect to be amazing"</p>
     `,
    accomplishmentsHtml: "",
  },

  {
    id: 9,
    name: "Milania Leone",
    education: "All American Classical Ballet",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "Florida, USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Milania_Leone.jpg",
    instagram: {
      name: "milanialeone",
      url: "https://www.instagram.com/milanialeone",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/dance_gear_etc.jpg",
      name: "Dance Gear Etc",
      office: "",
      address: "1705 Dale Mabry Hwy, Land O' Lakes, FL 33548, EE. UU.",
      tel: "+1 (813) 428-6989",
      website: "www.dancegearetc.com",
      instagram: {
        name: "jailapointegotthepointe",
        url: "https://www.instagram.com/jailapointegotthepointe",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
      Milania has been training in ballet since she was 18 months old. The moment she took her first steps everyone in the room took notice. 
      She has continued her ballet training at All American Classical Ballet located in Tampa, Florida and takes every opportunity to join any
       ballet & contemporary classes she can. From the moment she slipped her foot into her first pair of pointe shoes at Dance Gear Etc., 
       (Nikolay 2007 size 2) she has been determined that one day she will be dancing in her pointe shoes on stages all over the world.
      </p>
      <p class="p_contributors">
      She received the “Hope Award” at YAGP Tampa in 2023 and is “Clara” in the Nutcracker at All American Classical Ballet this coming December 2023.
      She continues to grow her ballet training with Nikolay, currently wearing Dream Pointe 2007.
      </p>
     `,
    accomplishmentsHtml: "",
  },

  {
    id: 10,
    name: "Angelina Escobar",
    education: "Inland Pacific Ballet",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA",
    birth: "08/21/2010",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Angelina_Escobar.jpg",
    instagram: {
      name: "Angelina.Adelle",
      url: "https://www.instagram.com/Angelina.Adelle",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/carolinadancewear.jpg",
      name: "Carolina Dancewear",
      office: "",
      address: "1627 New Garden Rd. Greensboro, North Carolina, USA",
      tel: "+1 (336) 856-9983",
      website: "www.carolinadancewear.com",
      instagram: {
        name: "carolinadancewear",
        url: "https://www.instagram.com/carolinadancewear",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
       Hi, my name is Angelina and I'm 13 years old. For the last 8 years, I've had the honor of training at Inland Pacific Ballet in Montclair, California.
        My primary training is classical ballet, but I enjoy acro, Jazz, and Contemporary. I am also in the Ensemble Program and have taken on various roles 
        in the professional production of “The Nutcracker". I've attended summer intensives at IPBA, ABT, and this year, I will attend summer intensives at 
        IPBA and Southland Academy in Orange County, California.
      </p>
      <p class="p_contributors">
       I love dancing and when I'm not, I enjoy the beach, spending time with my family and friends, and going to church. What I love most about dancing is the 
       ability to connect with others and tell a story. My favorite word is "perseverance" because to be a dancer you must overcome whatever comes your way. I am excited
      and grateful to be a Nikolay Influencer with Carolina dancewear, and like I always say...
      </p>
      <p class="p_contributors">
      "There simply is no other way than with Nikolay."
      </p>
     `,
    accomplishmentsHtml: "",
  },

  {
    id: 11,
    name: "Ava Zisko",
    education: "West Point Ballet",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA",
    birth: "03/08/2007",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Ava_Zisko.jpg",
    instagram: {
      name: "ava_zisko",
      url: "https://www.instagram.com/ava_zisko",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
      At the age of two I did a dance performance on stage. I came off stage and said “I am never doing that again”. 
      So my mom enrolled me in gymnastics and added a ballet class for fun. At age 5 my mom enrolled me in a competition studio.
       After two weeks the teacher asked if I would like to do competition dance.
      </p>
      <p class="p_contributors">
      On year 4 my mom wanted “formal ballet training”. At age 9 I started ballet full time six days a week and absolutely fell in love.
      </p>
      <p class="p_contributors">
      My mom put me in dance as I was extremely shy but dance has been a way for me to express myself and transform into another person. 
      I have been wearing Grishko2007/ Nikolay 3007 since age nine with my first pair of pointe shoes. Yes I did go en pointe at age 9, 
      however I was fully en pointe until age 10 and did weekly private lessons for an entire year for strength training.
      </p>
     `,
    accomplishmentsHtml: `
<ul class="list_contributors">
  <li>YAGP Champion</li>
  <li>YAGP (age 13) - 2nd place Classical / Top 12 Contemporary</li>
  <li>YAGP (age 12) - 3rd place Classical (Junior)</li>
  <li>YAGP (age 11) - 1st place Classical / 1st place Contemporary</li>
  <li>YAGP (age 10) - 3rd place Classical / 3rd place Contemporary</li>
  <li>YAGP (age 9) - Top 12 Classical / Contemporary</li>
  <li>YAGP Finals x4 - 2021, 2020, 2019, 2018</li>
  <li>ADC IBC 2022 - 2nd place Classical / 6th place Contemporary</li>
  <li>NYCDA 2021 - 1st Place Teen Solo - Pas D’Esclave</li>
  <li>Starbound 2021 - Teen Title</li>
  <li>OnStage NY 2021 - Teen Title</li>
  <li>UBC - Rising Star</li>
  <li>ProReveler 2021 / 2022</li>
</ul>

    `,
  },

  {
    id: 12,
    name: "Macie Miersch",
    education: "Sarasota Ballet's Margaret Barbieri Conservatory",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA",
    birth: "1/13/2009",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Macie_Miersch.jpg",
    instagram: {
      name: "maciemiersch",
      url: "https://www.instagram.com/maciemiersch",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/the_dance_wear_shoppe.jpg",
      name: "The DanceWEAR Shoppe",
      office: "",
      address: "315 Interstate Blvd, Sarasota, FL 34240, Estados Unidos",
      tel: "+1 (941) 312-6312",
      website: "www.thedancewearshoppe.com",
      instagram: {
        name: "www.thedancewearshoppe.com",
        url: "https://www.instagram.com/tdancewearshoppe/",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
      I am 14 years old and I have been dancing for almost my whole life. I currently train at Sarasota Ballet's Margaret Barbieri Conservatory 
      where I train around 30 hours a week. This past summer I attended American Ballet Theatre’s 5 week New York City summer intensive. I dream of
      dancing professionally at American Ballet Theatre, Houston Ballet, or Royal Ballet.
      </p>
      <p class="p_contributors">
      I truly love the Nikolay Brand. The pointe shoes are just incredible; they support me so well, allowing me to dance to my fullest while also 
      always ensuring that my feet are looking good!
      </p>
     `,
    accomplishmentsHtml: `
      <ul class="list_contributors">
      <li>Casted as “Little Girl” in August Bournonville’s <i>La Sylphide</i>, directed by Johan Kobborg for the Sarasota Ballet</li>
      <li>Portrayed Clara in the Sarasota Ballet’s <i>The Nutcracker</i></li>
      <li>YAGP Tampa Regional 2022 - 1st Place Classical</li>
      <li>YAGP Tampa Regional 2022 - 2nd Place Contemporary</li>
      <li>YAGP Pittsburgh Regional 2023 - 1st Place Pas de Deux</li>
      <li>YAGP International Finals - Top 12 Classical (Pas de Deux)</li>
      <li>YAGP International Finals - Top 12 Contemporary (Duet)</li>
      <li>YAGP Full Scholarship to ABT Summer Intensive 2023</li>
      <li>NYCDA 2021 - National Junior Outstanding Dancer</li>
    </ul>
    `,
  },

  {
    id: 13,
    name: "Berkley Zumwa",
    education: "South Mississippi Ballet Theatre",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Berkley_Zumwa.jpg",
    instagram: {
      name: "berkley_zumwalt",
      url: "https://www.instagram.com/berkley_zumwalt",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/grit_grace_studio_to_streetwear.jpg",
      name: "Grit & Grace Studio to Streetwear",
      office: "",
      address: "315 Interstate Blvd, Sarasota, FL 34240, Estados Unidos",
      tel: "+1 (678) 552-9798",
      website: "www.gritandgracedancewear.com",
      instagram: {
        name: "gritandgracestudiotostreetwear",
        url: "https://www.instagram.com/gritandgracestudiotostreetwear",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
        Berkley Zumwalt is 12 years old and is currently a student at South Mississippi Ballet Theatre in Hattiesburg, Mississippi.
         She began ballet training with SMBT at the age of eight under Arkadiy and Katya Orohovsky. Berkley is very passionate about ballet,
          but also enjoys other styles of dance, such as contemporary, jazz, and ballroom. Berkley has competed in several ballet competitions,
           including YAGP where she placed second and was a 2022 and 2023 finalist as well as placing first at ADC IBC and Top 15 at ADC IBC finals.
      </p>
      <p class="p_contributors">
       Berkley would love to join a professional ballet company one day. Her very first pair of pointe shoes at age nine were Nikolay Smart Pointes. 
       She is currently loving her Nikolay Nova pointe shoes! She looks forward to representing her favorite brand and is so very grateful for this wonderful opportunity.
      </p>
     `,
    accomplishmentsHtml: ``,
  },

  {
    id: 14,
    name: "Skylar Reeve",
    education: " Morning Star Dance Academy and the Master Ballet Academy",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Skylar_Reeve.jpg",
    instagram: {
      name: "skylarreeve2020",
      url: "https://www.instagram.com/berkley_zumwalt",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/grit_grace_studio_to_streetwear.jpg",
      name: "Grit & Grace Studio to Streetwear",
      office: "",
      address: "315 Interstate Blvd, Sarasota, FL 34240, Estados Unidos",
      tel: "+1 (678) 552-9798",
      website: "www.gritandgracedancewear.com",
      instagram: {
        name: "gritandgracestudiotostreetwear",
        url: "https://www.instagram.com/gritandgracestudiotostreetwear",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
        Skylar Reeve is a 12 year old passionate dancer from Atlanta, Georgia. She began studying dance at the young age of four.
         Skylar studies all forms of dance, including hip hop, jazz, folk; although, she especially enjoys classical ballet and contemporary dance.
          She has been training en pointe since the age of nine, and is currently training at Morning Star Dance Academy and the Master Ballet Academy.
           Skylar loves to perform, and her greatest inspiration is Juliet Doherty.
      </p>
      <p class="p_contributors">
       When Skylar is not dancing, she enjoys reading, baking, and playing piano.
      </p>
     `,
    accomplishmentsHtml: `
      <ul class="list_contributors">
      <li>YAGP Chicago 2021: 2nd Place in Classical, 3rd Place in Contemporary</li>
      <li>YAGP Tampa 2021 Finalist</li>
      <li>UBC Atlanta 2021: 3rd Place in Contemporary</li>
      <li>WBC 2021: Honorable Mention</li>
    </ul>
    `,
  },

  {
    id: 15,
    name: "Georgia Marko",
    education: "Tolbert Yilmaz School of Dance",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA",
    birth: "May 18, 2009",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Georgia_Marko.jpg",
    instagram: {
      name: "georgia_marko_",
      url: "https://www.instagram.com/georgia_marko_",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/grit_grace_studio_to_streetwear.jpg",
      name: "Grit & Grace Studio to Streetwear",
      office: "",
      address: "315 Interstate Blvd, Sarasota, FL 34240, Estados Unidos",
      tel: "+1 (678) 552-9798",
      website: "www.gritandgracedancewear.com",
      instagram: {
        name: "gritandgracestudiotostreetwear",
        url: "https://www.instagram.com/gritandgracestudiotostreetwear",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
        Miss Georgia Marko began her ballet training at the early age of 3 while living abroad in Singapore. 
        Upon returning to the states at age 5, she joined the Tolbert Yilmaz School of Dance in Roswell Georgia,
        where she has trained since. Ms. Tracey Bayly, the school’s ballet mistress, took her under her wing. Under Ms.
        Bayly, Georgia rose through the ranks to the highest level of the school’s resident PreProfessional company Roswell
        Dance Theatre.
        </p>
       <p class="p_contributors">
        Georgia has danced the roles of Mirliton, Clara, and Dream Queen in The Nutcracker, and this spring
        will dance the Spring Fairy role in Cinderella and the role of Maria in West Side Story. Georgia has competed and
        placed in both Youth America Grand Prix and Universal Ballet Competitions. She has spent summers training at The
        School of American Ballet and Houston Ballet Academy.
      </p>
      <p class="p_contributors">
       Georgia is thrilled to share her love of dance and all things Nikolay as one of this year’s Influencers.
      </p>
     `,
    accomplishmentsHtml: ``,
  },

  {
    id: 16,
    name: "Phoebe Allbright",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Phoebe_Allbright.jpg",
    instagram: {
      name: "phoebe.allbright",
      url: "https://www.instagram.com/phoebe.allbright/",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/sandys.jpg",
      name: "Sandy's Dancewear",
      office: "",
      address: "2211 Gus Thomasson Road Dallas, TX 75228",
      tel: "+1 (214) 321-1764",
      website: "www.sandysdancewear.com",
      instagram: {
        name: "sandys_dancewear",
        url: "https://www.instagram.com/sandys_dancewear",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
       Phoebe Allbright has been dancing since she was 5 years old at the Allen Conservatory of Dance. 
       She joined Allen Civic Ballet in 2020 and has danced in numerous classical and contemporary works. 
       Her favorite roles have included Clara, Arabian Queen and this year she is dancing her dream role of the Snow Queen.
      </p>
       <p class="p_contributors">
        Phoebe has attended the Cosmopolitan Ballet Theater with Miss Irina Vakhromeeva for the last 2 summers on scholarship.
        She will be auditioning this year for pre-professional programs in hopes to join a ballet company when she turns 18.
      </p>
     `,
    accomplishmentsHtml: ``,
  },

  {
    id: 17,
    name: "Bella Sacks",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "FL, USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Bella_Sacks.jpg",
    instagram: {
      name: "bella._.sacks",
      url: "https://www.instagram.com/bella._.sacks",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/dwc.jpg",
      name: "DanceWear Corner",
      office: "",
      address: "136 South Semoran Blvd Orlando, Florida 32807",
      tel: "+1 (877) 846-3338",
      website: "www.dancewearcorner.com",
      instagram: {
        name: "dancewearcorner",
        url: "https://www.instagram.com/dancewearcorner/",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
      Hi, my name is Bella Sacks and I live in Winter Park, Florida! I’ve always had a passion for dance, but mainly grew up acting and modeling.
       A couple of years ago, I made the decision to start homeschooling to further my ballet training. I’m very thankful to have received scholarships 
       and awards from multiple schools and prestigious ballet competitions throughout the years!
      </p>
       <p class="p_contributors">
       Nikolay has always had the highest quality pointe shoes and garments that have and continue to help me feel and dance my best. I can’t wait to see
        where my ballet journey takes me and I’m so grateful to be taking it as a part of the Nikolay family!
      </p>
     `,
    accomplishmentsHtml: ``,
  },

  {
    id: 18,
    name: "Julianne Gallagher",
    education: "School of NJ Ballet",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "NJ, USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Julianne_Gallagher.jpg",
    instagram: {
      name: "julianne._.ballet",
      url: "https://www.instagram.com/julianne._.ballet",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/discountdancewarehouse.jpg",
      name: "Discount Dance Warehouse",
      office: "",
      address: "136 South Semoran Blvd Orlando, Florida 32807",
      tel: "+1 (973) 448-1339",
      website: "www.discountdancewarehouse.com",
      instagram: {
        name: "discountdancewarehouse",
        url: "https://www.instagram.com/discountdancewarehouse",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
       Julianne Gallagher began dancing at the age of 3. She knew at a very young age dancing was her life. Sh
       e has trained in ballet, pointe, tap, contemporary, jazz, and hip hop. She has danced in shows such as 
       Coppelia, The Magic Toyshop, Hansel and Gretel, Peter and the Wolfe, and of course the Nutcracker. 
       Julianne has attended summer intensives at ABT New York City, Sarasota Ballet and New Jersey Ballet.
        At the age of 11, she made the transition to the School of NJ Ballet and began her focus on ballet 
        and pointe. Her favorite show to perform in, is the Nutcracker and is working towards her short term 
        goal of being Clara this year.
      </p>
       <p class="p_contributors">
       In her many years of pointe she has tried many different brands of pointe shoes and about 3 years ago, 
       discovered <a href="https://www.instagram.com/nikolayworld" class="p_link" target="_blank">nikolayworld</a>
         Her favorite make is the Nikolay StreamPointe and she loves their moleskin toe pads.
      </p>
         <p class="p_contributors">
       Julianne is extremely passionate about her love for dance. What she loves most is performing and seeing the joy on
        the faces of the audience. She loves to tell her story through her movements. Julianne will continue to work towards
         her goal of one day dancing with a professional company. When Julianne is not dancing, she enjoys spending time with
          her family and friends and cuddling with her dogs.
      </p>
     `,
    accomplishmentsHtml: ``,
  },

  {
    id: 19,
    name: "Ava Buckhalt",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "MD, USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Ava_Buckhalt.jpg",
    instagram: {
      name: "ava_buckhalt",
      url: "https://www.instagram.com/ava_buckhalt/",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/dance_supplies.png",
      name: "Dance Supplies",
      office: "",
      address: "136 South Semoran Blvd Orlando, Florida 32807",
      tel: "+1 (800) 903-2623",
      website: "www.dancesupplies.com",
      instagram: {
        name: "dancesupplies",
        url: "https://www.instagram.com/dancesupplies/",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
        A Minnesota native, Madelyn Murphy relocated to train with The Sarasota Ballet, Margaret Barberi Conservatory
        daytime program, and where she was cast as Clara, in The Nutcracker. Madelyn was accepted to Houston Ballet’s 
        summer intensive and invited to Festival of Nervi in Italy. Focused on classical ballet, pointe and contemporary,
        she has been invited to YAGP finals as a soloist, placed 1st, 3rd and Top 12 at numerous YAGP regional competitions,
        and top placements at UBC Grand Prix and ADC IBC. Madelyn was named Top10 Mini Best Dancer at The Dance Awards nationals
        and received numerous scholarships.
      </p>
       <p class="p_contributors">
       Madelyn is grateful for all her accomplishments, and she is thrilled to continue with the Nikolay family as a Nikolay Influencer!
        She appreciates all the amazing support from Petr, Riley and the Nikolay team.
      </p>
         <p class="p_contributors">
       Madelyn currently wears Starpointes, but also like the feel of Streampointe and 3007 along with her Moleskin toe pads to keep her at her best!
      </p>
     `,
    accomplishmentsHtml: ``,
  },

  {
    id: 20,
    name: "Madelyn Murphy",
    education: "Turning Pointe Dance Academy",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "MN, USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Madelyn_Murphy.jpg",
    instagram: {
      name: "madelynmurphydancer",
      url: "https://www.instagram.com/madelynmurphydancer/",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/dance_supplies.png",
      name: "Dance Supplies",
      office: "",
      address: "136 South Semoran Blvd Orlando, Florida 32807",
      tel: "+1 (800) 903-2623",
      website: "www.dancesupplies.com",
      instagram: {
        name: "dancesupplies",
        url: "https://www.instagram.com/dancesupplies/",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
       Julianne Gallagher began dancing at the age of 3. She knew at a very young age dancing was her life. Sh
       e has trained in ballet, pointe, tap, contemporary, jazz, and hip hop. She has danced in shows such as 
       Coppelia, The Magic Toyshop, Hansel and Gretel, Peter and the Wolfe, and of course the Nutcracker. 
       Julianne has attended summer intensives at ABT New York City, Sarasota Ballet and New Jersey Ballet.
        At the age of 11, she made the transition to the School of NJ Ballet and began her focus on ballet 
        and pointe. Her favorite show to perform in, is the Nutcracker and is working towards her short term 
        goal of being Clara this year.
      </p>
       <p class="p_contributors">
       In her many years of pointe she has tried many different brands of pointe shoes and about 3 years ago, 
       discovered <a href="https://www.instagram.com/nikolayworld" class="p_link" target="_blank">nikolayworld</a>
         Her favorite make is the Nikolay StreamPointe and she loves their moleskin toe pads.
      </p>
         <p class="p_contributors">
       Julianne is extremely passionate about her love for dance. What she loves most is performing and seeing the joy on
        the faces of the audience. She loves to tell her story through her movements. Julianne will continue to work towards
         her goal of one day dancing with a professional company. When Julianne is not dancing, she enjoys spending time with
          her family and friends and cuddling with her dogs.
      </p>
     `,
    accomplishmentsHtml: `
    <ul class="list_contributors">
    <li>1st Place Contemporary - 2022 YAGP Las Vegas Semi-Finals</li>
    <li>Top 12 Classical - 2022 YAGP Winston-Salem Semi-Finals</li>
    <li>3rd Place Contemporary - 2022 YAGP Winston-Salem Semi-Finals</li>
    <li>2022 YAGP International Finals - Soloist Invite</li>
    <li>Top 10 Mini Best Dancer - The Dance Awards 2022</li>
   </ul>
    `,
  },

  {
    id: 21,
    name: "Harper Anderson",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Harper_Anderson.jpg",
    instagram: {
      name: "harpsterjoy",
      url: "https://www.instagram.com/harpsterjoy",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
      Harper Anderson has been dancing since she was 4 years old, now 12 she lives and trains in Minnesota, studying at Concept Pavielle.
      </p>
       <p class="p_contributors">
       Harper has spent her summers studying at School of American Ballet, Elite Classical Coaching, Ballet Academy East, and A & A Ballet. 
       She has been a successful competitor attending YAGP Finals in 24, 23 and 22. Harper was the recipient of the Hope Award at YAGP New York 
       regional 2023 and was also awarded the Rising Star Award at UBC finals in 2023.
      </p>
        <p class="p_contributors">
      Harper aspires to be a professional ballerina traveling the world doing what she loves. Since 9 years old when she started pointe she has fallen 
      in love with the Nikolay brand and is excited to share her love of Nikolay and ballet with other aspiring ballerinas!
      </p>
     `,
    accomplishmentsHtml: ``,
  },

  {
    id: 22,
    name: "Emily Kim",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "MD, USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Emily_Kim.jpg",
    instagram: {
      name: "_emily_kim_",
      url: "https://www.instagram.com/_emily__kim_/",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/dance_supplies.png",
      name: "Dance Supplies",
      office: "",
      address: "136 South Semoran Blvd Orlando, Florida 32807",
      tel: "+1 (800) 903-2623",
      website: "www.dancesupplies.com",
      instagram: {
        name: "dancesupplies",
        url: "https://www.instagram.com/dancesupplies/",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
       Emily Kim is an aspiring professional dancer from Maryland. She has been dancing since she was four years old, 
       and has been training en pointe since the age of ten. She is honored to represent Dance Supplies and Nikolay as a Nikolay Influencer.
      </p>
       <p class="p_contributors">
       Emily studies the Cecchetti Method of Ballet at Turning Pointe Dance Academy (TPDA). She is also a member of TPDA’s Ballet Conservatory Program. 
       She studies several types of dance, but her favorite genres are ballet and contemporary. Emily has received many awards and scholarships from dance.
        Some of her proudest accomplishments are 2nd place Contemporary (YAGP Philadelphia 2020), 2nd runner up National Miss Teen StarPower (StarPower 2021), 
        1st place overall soloist (StarPower Baltimore 2023), 2nd place teen soloist (NUVO Baltimore 2024) and numerous scholarships from NYCDA, Ballet Hispanico,
         JUMP, NUVO, 24Seven and Radix.
      </p>
      <p class="p_contributors">
       Outside of dance, she enjoys modeling. She is a model for Weissman Costumes, Chic Ballet Dancewear, Class In Dancewear and Blue Water Dancewear. 
       When she is not dancing, she loves to travel and spend time with her friends and two cats.
      </p>
     `,
    accomplishmentsHtml: ``,
  },

  {
    id: 23,
    name: "Siena Minnick",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "GA, USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Siena_Minnick.jpg",
    instagram: {
      name: "siena_minnick_dance",
      url: "https://www.instagram.com/siena_minnick_dance/",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/dance_supplies.png",
      name: "Dance Supplies",
      office: "",
      address: "136 South Semoran Blvd Orlando, Florida 32807",
      tel: "+1 (800) 903-2623",
      website: "www.dancesupplies.com",
      instagram: {
        name: "dancesupplies",
        url: "https://www.instagram.com/dancesupplies/",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
      Siena started dancing when she was 3 years old and hopes to be a professional dancer. Her favorite style of dance is ballet, 
      but she also loves contemporary, modern and jazz.
      </p>
       <p class="p_contributors">
       Siena danced the roles of Clara and Snow Queen in productions at her performing arts school, Garrison School for the Arts, 
       and with her home studio, The Studio Savannah, at the Historic Savannah Theatre. She danced in Sleeping Beauty and Snow White
        with the State of Ukraine Ballet and We Dance Academics.
      </p>
      <p class="p_contributors">
      Siena assists the younger classes and competes with her home studio and is an assistant with Revel Dance Convention for the ‘23-‘24 season.
      </p>
       <p class="p_contributors">
      Siena spent the past three summers training at Ellison Ballet, the Cary Ballet Conservatory, Ballet West and Miami City Ballet.
       This summer she is attending the Harid Conservatory on scholarship.
      </p>
     `,
    accomplishmentsHtml: ``,
  },

  {
    id: 24,
    name: "Annalisa Verrilli",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "GA, USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Annalisa_Verrilli.jpg",
    instagram: {
      name: "annalisa.verrilli",
      url: "https://www.instagram.com/annalisa.verrilli/",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/attitude_dance_active_wear.jpg",
      name: "Attitude Dance & Active Wear",
      office: "",
      address: "181 Westport Avenue, Norwalk, CT 06851, USA",
      tel: "+1 (203) 838-4002",
      website: "www.attitudenorwalk.com",
      instagram: {
        name: "attitudenorwalk",
        url: "https://www.instagram.com/attitudenorwalk/",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
       Annalisa Verrilli is an aspiring ballerina who received her training at Greenwich Ballet Academy in Greenwich CT. In September she will be
        furthering her studies at Elite Classical Coaching, a Nikolay Partner School. She has attended several summer intensives, including Russian
         Masters Ballet, Harid Conservatory, Ellison Ballet and Bolshoi Ballet Academy.
      </p>
       <p class="p_contributors">
       Annalisa wears Nikolay Novas and absolutely loves everything in the Nikolay catalog. She shops for all of her Nikolay shoes and apparel at
        Attitude Dance & Active Wear.
      </p>
      <p class="p_contributors">
      Siena assists the younger classes and competes with her home studio and is an assistant with Revel Dance Convention for the ‘23-‘24 season.
      </p>
       <p class="p_contributors">
     Annalisa dreams of being in a professional ballet company and loves classical ballet very much. She is excited to become a part of the Nikolay 
     family and is very grateful for the opportunity to represent her favorite brand.
      </p>
     `,
    accomplishmentsHtml: ``,
  },

  {
    id: 25,
    name: "Jada Brown",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "FL, USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Jada_Brown.jpg",
    instagram: {
      name: "ballerina_jadagrace",
      url: "https://www.instagram.com/ballerina_jadagrace/",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/sandys.jpg",
      name: "En Pointe Dancewear Boutique",
      office: "",
      address: "13081 W Sunrise Blvd, Sunrise, FL 33323, USA",
      tel: "+1 (954) 707-0001",
      website: " www.enpointeboutique21.com",
      instagram: {
        name: "enpointe_boutique21",
        url: "https://www.instagram.com/enpointe_boutique21/",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
      Jada Brown is 14 years old and from South Florida. She discovered her love of dance at an early age and has dedicated her young life to this passion. 
      She is currently training full-time with her teacher/coach Michelle Chaviano at SoFlo Movement Center in South Florida. Jada’s studies include ballet, 
      contemporary, contemporary ballet, modern, jazz and tap. Jada attends Calvary Christian Academy where she is part of the dance program.
      </p>
       <p class="p_contributors">
      She has competed at many well-regarded competitions such as YAGP, ADC/IBC, MIAMI IBC, and UBC, where she placed in the top 20. Jada also received a full 
      scholarship to The Royal Winnipeg Ballet Summer Program at UBC 2023 and received a scholarship to attend The Dance Theatre of Harlem Summer Program at Miami 
      IBC in 2023. She has also attended the 2022 Summer Intensive program at Miami City Ballet where she received an invitation to train there for the 2022-2023 
      Season and then attended Houston Ballet Summer Intensive this past summer.
      </p>
     `,
    accomplishmentsHtml: ``,
  },

  {
    id: 26,
    name: "Sienna Laggne",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Sienna_Laggne.jpg",
    instagram: {
      name: "sienna_the_ballerina",
      url: "https://www.instagram.com/sienna_the_ballerina/",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/sandys.jpg",
      name: "Sandy's Dancewear",
      office: "",
      address: "2211 Gus Thomasson Road Dallas, TX 75228",
      tel: "+1 (214) 321-1764",
      website: "www.sandysdancewear.com",
      instagram: {
        name: "sandys_dancewear",
        url: "https://www.instagram.com/sandys_dancewear",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
      Sienna started dancing at the age of 3 at Royale Ballet Dance Academy. She has attended summer intensives at RBDA, The Dallas Conservatory,
       Texas Ballet Theater, Dallas Ballet Center and Annarella International Conservatory of Ballet and Dance in Portugal. Performing in the Nutcracker
        is always a highlight of her year. She has been a Cotton Candy, Chrysanthemum, Chinese trio, Rose, Snowflake and Harlequin Doll duet. She loves 
        her Nikolay SmartPointe shoes. They make her feel secure and able to do what she loves.
      </p>
       <p class="p_contributors">
        Sienna is passionate about ballet and hopes to one day become a professional dancer!
      </p>
     `,
    accomplishmentsHtml: ``,
  },

  {
    id: 27,
    name: "Stirling Jones",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Stirling_Jones.jpg",
    instagram: {
      name: "stirling.jones",
      url: "https://www.instagram.com/stirling.jones/",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/sandys.jpg",
      name: "Sandy's Dancewear",
      office: "",
      address: "2211 Gus Thomasson Road Dallas, TX 75228",
      tel: "+1 (214) 321-1764",
      website: "www.sandysdancewear.com",
      instagram: {
        name: "sandys_dancewear",
        url: "https://www.instagram.com/sandys_dancewear",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
       Stirling started dancing at the age of 3. She started her ballet education at RBDA in Dallas and is currently in the Professional 
       Training Program at <a href="https://www.instagram.com/CaryBallet/" class="p_link" target="_blank">CaryBallet</a> in North Carolina.
      </p>
       <p class="p_contributors">
        She has attended many summer intensives including English National Ballet School, Texas Ballet Theater School, Cary Ballet and Annarella
         International Conservatory of Ballet and Dance in Portugal.
      </p>
       <p class="p_contributors">
       Even from a very young age her passion was evident, and it has only grown as she continues to pursue her goal of joining a professional company. 
       Her favorite pointe shoe is the Nikolay 3007s and she is excited about her partnership with Nikolay and Sandys Dancewear as an influencer.
      </p>
     `,
    accomplishmentsHtml: ``,
  },

  {
    id: 28,
    name: "Gisele Wilson",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Gisele_Wilson.jpg",
    instagram: {
      name: "giseletheballerina",
      url: "https://www.instagram.com/giseletheballerina/",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/sandys.jpg",
      name: "Sandy's Dancewear",
      office: "",
      address: "2211 Gus Thomasson Road Dallas, TX 75228",
      tel: "+1 (214) 321-1764",
      website: "www.sandysdancewear.com",
      instagram: {
        name: "sandys_dancewear",
        url: "https://www.instagram.com/sandys_dancewear",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
       Gisele Elise is a 14 year old ballet dancer. She current trains with Cody Toscano at Hathaway Academy of Ballet. Gisele has studied dance abroad
        at Princesse Grace Academy (Monaco), Academia a la Scala (Milan), Elhurst Ballet School (Birmingham, UK), John Cranko Schule (Stuttgart, Germany),
         European School of Ballet (Amsterdam, Netherlands), Paris Opera Ballet School (Paris, France), and the Royal Ballet School (London, England). 
      </p>
       <p class="p_contributors">
          This season Gisele competed in the Youth Grand Prix in Paris, and was awarded Top 12 in the Junior Classical category. She also competed in the 
         YAGP Las Vegas Semi-Final, where she was awarded 1st Place Junior Classical and Top 12 Junior Contemporary.
      </p>
     `,
    accomplishmentsHtml: ``,
  },

  {
    id: 29,
    name: "Salome Prada",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Salome_Prada.jpeg",
    instagram: {
      name: "giseletheballerina",
      url: "https://www.instagram.com/giseletheballerina/",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/sandys.jpg",
      name: "Sandy's Dancewear",
      office: "",
      address: "2211 Gus Thomasson Road Dallas, TX 75228",
      tel: "+1 (214) 321-1764",
      website: "www.sandysdancewear.com",
      instagram: {
        name: "sandys_dancewear",
        url: "https://www.instagram.com/sandys_dancewear",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
       Hello, my name is Salomé Prada, and I am a freshman at Baylor University with a major in Biology. I have been dancing since I was a child,
        but started focusing solely on ballet in high school. During that time, I traveled extensively with my siblings to meet and dance with ballerinas
         from several different countries. Presently, I attend classes virtually with <a href="https://www.instagram.com/classicalrussianballetacademy/" class="p_link" target="_blank">
         classicalrussianballetacademy</a> in The Hague, Netherlands. At Baylor,
        I am excited to become a part of the Baylor Ballet Club and share my love for Nikolay with my new ballet friends.
      </p>
       <p class="p_contributors">
       <a href="https://www.instagram.com/sandys_dancewear" class="p_link" target="_blank">sandys_dancewear</a> has been my go-to spot for all things ballet since it is so close to my
        university. I am so excited to join the Nikolay family and couldn’t be more grateful for this opportunity!
      </p>
     `,
    accomplishmentsHtml: ``,
  },

  {
    id: 30,
    name: "Olivia Mager",
    education: "West Point Ballet",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA, PA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Olivia_Mager.jpg",
    instagram: {
      name: "olivia_mager",
      url: "https://www.instagram.com/olivia_mager",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
      Olivia is 13 years old and began her dance journey at the age of 11. She started at a competition studio exploring various styles of dance, 
      but her true passion is ballet. This year, she made the decision to focus exclusively on ballet, and trains at West Point Ballet.</p>

       <p class="p_contributors">
       Dance provides her with a voice through which she expresses her true self. She feels there is truly no better 
       feeling than performing on stage, where she can share her art with others.
       </p>

        <p class="p_contributors">
        In her pursuit of ballet, she has experimented with different pointe shoes. However, after trying the DreamPointe 2007 Nikolay pointe shoe she
         knew she had found her perfect fit. Not only do they look stunning, but they are also the most comfortable and reliable pointe shoe she has ever danced in.
       </p>
     `,
    accomplishmentsHtml: ``,
  },

  {
    id: 31,
    name: "Gabriella Folsom",
    education: "",
    market: "Nikolay Market Influencer",
    category: "Nikolay Influencer",
    country: "USA",
    birth: "10/14/2010",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Influencers/Gabriella_Folsom.jpg",
    instagram: {
      name: "gabriella.folsom",
      url: "https://www.instagram.com/gabriella.folsom/",
    },
    company: {
      logo: "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/logos/Empire_Dance_Shop.jpg",
      name: "Empire Dance Shop",
      office: "",
      address: "2211 Gus Thomasson Road Dallas, TX 75228",
      tel: "+1 (509) 747-7808",
      website: "www.empiredanceshop.com",
      instagram: {
        name: "empiredanceshop",
        url: "https://www.instagram.com/empiredanceshop/",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
       Gabriella Folsom, 14 years old, is from Spokane, Washington. She is currently in the 9th Grade and training at The Rock School for 
       Dance in the Professional Division in Philadelphia, Pennsylvania, and has attended Summer Intensives at School of American Ballet 
       and Pacific Northwest Ballet. She started dancing when she was 6 years old, and is proficient in all styles of dance, but Ballet is her passion. 
      </p>
       <p class="p_contributors">
       Before moving to Philly, she was at a competition dance studio in her hometown. During the 2025 Competition Season, she won first place overall 
       with her contemporary solo at Leap, KAR and Starpower. She also received a silver medal at MusicFest Northwest in Spokane and YAGP Top 24 
       Classical in San Diego.
      </p>
     `,
    accomplishmentsHtml: ``,
  },
];
